const TabHasError = (tab, errors) => {
    let result = false
    if(errors){
        Object.keys(errors).map((key)=> {
            if(key.includes(`${tab}.`)){
                result = true
            }
        })
    }
    return result
}

export {TabHasError}